import { render, staticRenderFns } from "./tiplist.vue?vue&type=template&id=6e65397d&scoped=true&"
import script from "./tiplist.vue?vue&type=script&lang=js&"
export * from "./tiplist.vue?vue&type=script&lang=js&"
import style0 from "./tiplist.vue?vue&type=style&index=0&id=6e65397d&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e65397d",
  null
  
)

export default component.exports